export default {
  name: 'MenuCommonDialog',
  props: {
    cancelText: {
      default: '不刪除',
      type: String,
    },
    confirmText: {
      default: '刪除',
      type: String,
    },
    contentText: {
      default: '確定要刪除嗎？',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '刪除',
      type: String,
    },
    value: {
      required: true,
      type: Boolean,
    },
  },
};
